import { BASE_URL, FETCH_TRANSACTION_SETTINGS_CODE, INSERT_TRANSACTION } from "../config";
import { getSessionId } from "../utils/SessionHandler";

export class DraftApiError extends Error {
  constructor(status, message) {
    super(message);
    this.status = status;
  }
}

// Deliberately isolated from apiHelper: non-2xx MUST reject, and 204 has no JSON.
export async function strictDraftRequest(path, { method = "GET", body } = {}) {
  const response = await fetch(`${BASE_URL.replace(/\/$/, "")}/${path.replace(/^\//, "")}`, {
    method,
    cache: "no-store",
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${getSessionId()}` },
    ...(body === undefined ? {} : { body: JSON.stringify(body) }),
  });
  if (response.status === 204 && response.ok) return null;
  const data = await response.json().catch(() => null);
  if (!response.ok) {
    throw new DraftApiError(response.status, data?.error?.message || data?.message || data?.description || data?.error?.description || `Request failed (${response.status})`);
  }
  if (!data) throw new DraftApiError(response.status, "Invalid server response");
  return data;
}
const root = "api/v1/organisation/drafts";
export const draftsApi = {
  list: (page = 1, count = 20) => strictDraftRequest(`${root}?page=${page}&count=${count}`),
  get: (id) => strictDraftRequest(`${root}/${encodeURIComponent(id)}`),
  getTransactionSettings: async (code) => {
    const settings = await strictDraftRequest(`${FETCH_TRANSACTION_SETTINGS_CODE}${encodeURIComponent(code)}`);
    if (!settings || Array.isArray(settings) || typeof settings.type !== "string" || !settings.type) {
      throw new Error("Invalid transaction settings response.");
    }
    return settings;
  },
  create: (body) => strictDraftRequest(root, { method: "POST", body }),
  update: (id, body) => strictDraftRequest(`${root}/${encodeURIComponent(id)}`, { method: "PUT", body }),
  remove: (id, revision) => strictDraftRequest(`${root}/${encodeURIComponent(id)}?revision=${encodeURIComponent(revision)}`, { method: "DELETE" }),
};
// Only used by the opt-in NEW generic entry adapter, never edit/specialised calls.
export const insertDraftTransaction = (body, code) => strictDraftRequest(`${INSERT_TRANSACTION}${encodeURIComponent(code)}`, { method: "POST", body });